<template>
  <Panel header="Tarjeta" :toggleable="true" ref="panel" v-model:collapsed="isCollapsed" >
    <template #icons>
        <Tag> ({{cuil}} | {{nombre}})</Tag>
    </template>
    <div class="grid grid-cols-3 gap-4">
      <div class="col-span-3 hidden mb-4 sm:block">
        <h5><i class="pi pi-credit-card"></i>Tarjeta</h5>
        <Textarea v-model="tarjeta" rows="2" cols="60" class="text-xs w-full" style="color: transparent;text-shadow: 0 0 8px rgba(0,0,0,0.5);"
            @keyup.enter="callTarjeta" :disabled="bloquear"/>
      </div>
      <div class="col-span-1">
        <div class="field">
          <label for="cuil">CUIL</label>
          <AutoComplete name="cuil" v-model="datos" :suggestions="filteredCuil" @complete="getData($event)" optionLabel="cuil" forceSelection :delay="1000"
            class="mt-1 w-full rounded-md noboton" ref="input_cuil" :dropdown="true" @item-select="completeInfo" :disabled="bloquear" :minLength="3">
            <template #item="slotProps">
              <div class="flex flex-row">
                <div>
                  <span :class="{'bg-red-100': slotProps.item.idMotivoBaja!==0, 'text-red-800': slotProps.item.idMotivoBaja!==0, 
                      'bg-green-100': slotProps.item.idMotivoBaja===0, 'text-green-800': slotProps.item.idMotivoBaja===0}" 
                      class="text-xs font-semibold mr-2 px-2.5 py-0.5 rounded">
                    <i v-if="slotProps.item.idMotivoBaja===0" class="pi pi-check"></i>
                    <i v-else class="pi pi-times"></i>
                  </span>
                </div>
                <div>
                  <div v-if="slotProps.item.titular">
                    <Tag class="mr-2" icon="pi pi-user" value="Titular"></Tag>
                  </div>
                </div>
                <div>
                  {{slotProps.item.cuil}} -
                  {{slotProps.item.nombre}} -
                  {{slotProps.item.a_Numero}}
                </div>
              </div>
            </template>
          </AutoComplete>
        </div>
      </div>
      <div class="col-span-2">
        <div class="field">
          <label for="cuildata">NOMBRE</label>
          <InputText v-model="nombre" class="w-full" id="cuildata" type="text" disabled />
        </div>
      </div>
      <div class="col-span-1">
        <div class="field">
          <label for="titular">TITULAR</label>
          <InputText v-model="titular" class="w-full" id="titular" type="text" disabled />
        </div>
      </div>
      <div class="col-span-2">
        <div class="field">
          <label for="titulardata">NOMBRE</label>
          <InputText v-model="nombre2" class="w-full" id="titulardata" type="text" disabled />
        </div>
      </div>
      <!-- <div class="col-span-6">
        <Button v-if="bloquear" @click="cancelarEvent" label="Cambiar de afiliado" icon="pi pi-replay" class="p-button-sm p-button-warning" />
        <Button v-else @click="aceptarEvent" label="Aceptar" :disabled="loading" class="p-button-sm" :icon="loading ? 'pi pi-spin pi-spinner': 'pi pi-check'" />
      </div> -->
      <div class="col-span-1 grid grid-cols-2">
        <div class="col-span-2 sm:col-span-1">
          <Button v-show="idafiliado!==0" label="Familia" class="p-button-sm p-button-outlined" @click.stop="aceptarEvent" />
        </div>
        <div class="col-span-2 sm:col-span-1">
          <Button v-show="idafiliado!==0" label="Consumo" class="p-button-sm p-button-outlined" />
        </div>
      </div>
    </div>
  </Panel>
  <br />
  <div class="col-span-6 sm:col-span-1">
    <Button v-if="bloquear" @click="cancelarEvent" label="Cambiar de afiliado" icon="pi pi-replay" class="p-button-sm p-button-warning" />
  </div>
</template>

<script>
  import { ref, watch } from 'vue';
  import Panel from 'primevue/panel';
  import Textarea from 'primevue/textarea';
  import InputText from 'primevue/inputtext';
  import Button from 'primevue/button';
  import AutoComplete from 'primevue/autocomplete';
  import Tag from 'primevue/tag';

  import WService from '@/plugins/ws';

  export default {
    components: {
      Panel, Textarea, InputText, Button, AutoComplete, Tag
    },
    emits: ['devolverAfiliado'],
    setup(props, { emit }) {
      const wService = ref(new WService());
      const tarjeta = ref("");
      const datos = ref([]);
      const input_cuil = ref(null);
      const panel = ref(null);
      const cuil = ref("");
      const nombre = ref("");
      const titular = ref("");
      const nombre2 = ref("");
      const idafiliado = ref(0);
      const bandera = ref(0);
      const loading = ref(false);
      const bloquear = ref(false);
      const filteredCuil = ref([]);
      const isCollapsed = ref(false);

      //busca afiliados para mostrar en autocomplete
      const getData = (event) => {
        if (!loading.value) {
          loading.value = true;
          setTimeout(() => {
            if (event.query.length > 4 || event.query.length === 0) {
              wService.value.getMethod('afiliados/iosepsalud/' + event.query).then(info => {
                filteredCuil.value = info.filter(fila => fila.titular == true);
                loading.value = false;
              }).catch (err => {
                console.log(err.message);
                loading.value = false;
              });
            }
            else
              loading.value = false;
          }, 250);
        }
      };

      //rellena los campos restantes
      const completeInfo = (event) => {
        
        let data = event.value;
        if (data.titular) {
          titular.value = data.cuil;
          nombre2.value = data.nombre;
        }
        else {
          titular.value = data.cTitular;
          nombre2.value = data.nTitular;
        }
        idafiliado.value = data.idAfiliado;
        cuil.value = data.cuil;
        nombre.value = data.nombre;
        aceptarEvent();
      };

      //Verifica los enter presionados.
      const callTarjeta = () => {
        if (tarjeta.value.trim() === "") {
          input_cuil.value.$el.focus();
        }
        else {
          bandera.value++;
          if (bandera.value >= 2) {
            bandera.value = 0;
            //getData(""); //TODO: Revisar con tarjeta real.
          }
        }
      };

      //Boton aceptar
      const aceptarEvent = () => {
        bloquear.value = true;
        if (event) {
          event.preventDefault();
        };
        llamarEmit();
      }

      const llamarEmit = () => {
        panel.value.toggle();
        emit("devolverAfiliado", idafiliado.value);
      }

      //Cambia de afiliado
      const cancelarEvent = () => {
        bloquear.value = false;
        input_cuil.value.$el.focus();
        cuil.value = tarjeta.value = nombre.value = "";
        titular.value = nombre2.value = "";
        idafiliado.value = bandera.value = 0;
        filteredCuil.value = datos.value = [];
        isCollapsed.value = false;
      }

      //Verifica si la lectura de tarjeta fue correcta.
      watch(tarjeta, async (newValue) => {
        let canAmp = newValue.split("&").length - 1;
        if (canAmp == 5) {
          let lastAmp = newValue.lastIndexOf("&");
          let findEne = newValue.indexOf("_�", lastAmp);
          if (findEne != -1) {
            let canQues = newValue.split("�").length - 1;
            if (canQues >= 12) {
              var lastChar = newValue.substr(newValue.length - 1);
              if (lastChar == "_")
                getData(""); //TODO: Revisar con tarjeta real.
            }
          }
        }
      });

      return {
        tarjeta, datos, input_cuil, cuil, nombre, titular, nombre2, loading,
        filteredCuil, idafiliado, bloquear, panel, isCollapsed,

        getData, callTarjeta, completeInfo, aceptarEvent, cancelarEvent
      }
    },
  }
</script>
